import { render } from "./TestReportTab.vue?vue&type=template&id=6b418441&scoped=true"
import script from "./TestReportTab.vue?vue&type=script&lang=js"
export * from "./TestReportTab.vue?vue&type=script&lang=js"

import "./TestReportTab.vue?vue&type=style&index=0&id=6b418441&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b418441"]])

export default __exports__